<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Descrizione del caso</label>
                    <b-form-textarea v-if="!isReadOnly" max-rows="20" rows="10" v-model="jsonData.descrizioneCaso"></b-form-textarea>
                    <span v-else>{{ jsonData.descrizioneCaso }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Quadro psicopatologico</label>
                    <b-form-textarea v-if="!isReadOnly" max-rows="20" rows="10" v-model="jsonData.quadroPsicopatologico"></b-form-textarea>
                    <span v-else>{{ jsonData.quadroPsicopatologico }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Patologie organiche rilevanti</label>
                    <b-form-textarea v-if="!isReadOnly" max-rows="20" rows="10" v-model="jsonData.patologieOrganicheRilevanti"></b-form-textarea>
                    <span v-else>{{ jsonData.patologieOrganicheRilevanti }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Terapia farmacologica attuale</label>
                    <b-form-textarea v-if="!isReadOnly" max-rows="20" rows="10" v-model="jsonData.terapiaFarmacologicaAttuale"></b-form-textarea>
                    <span v-else>{{ jsonData.terapiaFarmacologicaAttuale }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            pathResourcePTI: "/rsapazientesrpti",
            jsonData: {
                id: null,
                idAccettazione: null,
                descrizioneCaso: "",
                quadroPsicopatologico: "",
                patologieOrganicheRilevanti: "",
                terapiaFarmacologicaAttuale: "",
                nomeProgetto: "PTI",
                params: "",
                dataFine: null,
                dataInizio: null,
            },
            nomeProgetto: "PTI",
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { PTI: "si" };
        me.params = JSON.stringify(params);

        me.jsonData = {
            idAccettazione: me.idAccettazione,
            descrizioneCaso: "",
            quadroPsicopatologico: "",
            patologieOrganicheRilevanti: "",
            terapiaFarmacologicaAttuale: "",
            nomeProgetto: "PTI",
            params: me.params,
            dataFine: null,
            dataInizio: new Date().getTime(),
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePTI + "/" + me.idRisorsa, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
            console.log(me.jsonData.nomeProgetto);
        },
        loadDataError(error) {
            console.log(error);
        },
    },
};
</script>
